var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"emails"}},[_c('h2',[_vm._v("\n    Targeted Emails\n  ")]),_vm._v(" "),_c('email-nav'),_vm._v(" "),_c('pagination',{ref:"pagination",attrs:{"resourceUrl":_vm.resourceUrl,"orderBy":"created_at","orderType":"DESC","attrIncludes":""},scopedSlots:_vm._u([{key:"paged_item",fn:function(item){return [_c('router-link',{staticClass:"list-group-item list-group-item-action",attrs:{"to":{
          name: 'email',
          params: {
            emailId: item.id
          }
        }}},[_vm._v("\n        "+_vm._s(item.display_name)+"\n          "),_c('span',{staticClass:"badge badge-secondary"},[_vm._v("\n            "+_vm._s(item.status)+"\n          ")])])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae19f81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Emails.vue
// module id = 1184
// module chunks = 1